export const showToast = (message, type = 'success') => {
    const toast = document.createElement('div');
    toast.classList.add('fixed', 'top-[10%]', 'right-[50%]', 'transform', 'translate-x-1/2', 'z-50');

    // Usa cores de preferência do usuário (primary para success, rosee para error)
    const toastTypes = {
        success: {
            icon: '<i class="fa-solid fa-check text-base"></i>',
            bg: 'bg-primary-50 dark:bg-primary-900/20',
            border: 'border-primary-300 dark:border-primary-700',
            shadow: 'shadow-lg shadow-primary-500/10 shadow-[0_12px_32px_rgba(0,0,0,0.4)]',
            iconBg: 'bg-primary-100 dark:bg-primary-800',
            iconText: 'text-primary-600 dark:text-primary-400',
            text: 'text-primary-900 dark:text-primary-100',
        },
        error: {
            icon: '<i class="fa-solid fa-triangle-exclamation text-base"></i>',
            bg: 'bg-rosee-50 dark:bg-rosee-900/20',
            border: 'border-rosee-300 dark:border-rosee-700',
            shadow: 'shadow-lg shadow-rosee-500/10 shadow-[0_12px_32px_rgba(0,0,0,0.4)]',
            iconBg: 'bg-rosee-100 dark:bg-rosee-800',
            iconText: 'text-rosee-600 dark:text-rosee-400',
            text: 'text-rosee-900 dark:text-rosee-100',
        },
    };

    const style = toastTypes[type] || toastTypes.success;

    toast.innerHTML = `
    <div class="relative flex items-center w-full max-w-xs p-4 mb-4 ${style.bg} ${style.border} ${style.shadow} border-2 rounded-xl backdrop-blur-sm" role="alert">
      <div class="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 ${style.iconBg} rounded-lg shadow-sm">
        ${style.icon}
        <span class="sr-only">Icon</span>
      </div>
      <div class="ms-3 text-sm font-semibold ${style.text}">${message}</div>
    </div>
  `;

    document.body.appendChild(toast);

    setTimeout(() => {
        toast.remove();
        document.querySelectorAll('.fixed.inset-0').forEach(el => el.remove());
    }, 2500);
};


export const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text?.trim()).then(() => {
        showToast('Copiado para a área de transferência');
    }).catch(err => {
        console.error('Erro ao copiar texto: ', err);
    });
};

export const getIcons = {
    file: () => `
    <svg  aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"/>
    </svg>
    `,
    text: () => `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6.2V5h11v1.2M8 5v14m-3 0h6m2-6.8V11h8v1.2M17 11v8m-1.5 0h3"/>
    </svg>`,
    link: () => `
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
    </svg>`,
};

export const isLink = (text) => {
    const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]|(\b[-A-Z0-9+&@#\/%=~_|!:,.;]*\.(com|org|net|gov|edu|co|info|br)\b))/ig;
    return urlPattern.test(text?.trim());
};

export const linkify = (text) => {
    const normalizedText = text?.replace(/\s+/g, ' ').trim();
    const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]|(\b[-A-Z0-9+&@#\/%=~_|!:,.;]*\.(com|org|net|gov|edu|co|info|br)\b))/ig;

    return normalizedText.replace(urlPattern, (match) => {
        if (!match.includes(window.location.hostname)) {
            return `<a class="text-blue-500" href="${match}" target="_blank">${match}</a>`;
        }
        return match;
    });
};
